import { For, Show, type JSX } from 'solid-js'
import type { BucketReadingsScope } from 'mormaii-web-presentation/bucket-readings'

import { Modal } from '../dialog'
import { Loading } from '../ui'

import Css from './bucket-dialog.module.scss'

type BucketDialogProps = { scope: BucketReadingsScope }

/**
 * O detalhamento de uma celula: as leituras cruas que ela resumiu.
 *
 * Existe porque a tabela passou a agrupar por hora. Sem ele, agrupar teria TIRADO
 * informacao - antes cada linha era uma leitura, e depois de resumir nao haveria
 * como chegar nelas. O detalhe do paciente e o historico compartilhado o desenham
 * igual; de onde as leituras vieram e assunto do presenter.
 */
export function BucketDialog(props: BucketDialogProps): JSX.Element {
    return (
        <Show when={props.scope.open}>
            <Modal title={props.scope.title} onClose={() => void props.scope.onClose()}>
                <Show when={!props.scope.loading} fallback={<Loading />}>
                    <Show
                        when={props.scope.readings.length > 0}
                        fallback={<p class={Css.noReading}>Nenhuma medição nesta hora.</p>}
                    >
                        <p class={Css.howMany}>{props.scope.readings.length} medição(ões) nesta hora.</p>
                        <ul class={Css.readings}>
                            <For each={props.scope.readings}>
                                {(reading) => (
                                    <li class={Css.reading}>
                                        <span class={Css.time}>{reading.time}</span>
                                        <span class={Css.measure}>
                                            <Show when={reading.statusName}>
                                                <span
                                                    class={Css.dot}
                                                    style={{ 'background-color': reading.statusColor }}
                                                    title={reading.statusName}
                                                />
                                            </Show>
                                            <span class={Css.value}>{reading.value}</span>
                                        </span>
                                    </li>
                                )}
                            </For>
                        </ul>
                    </Show>
                </Show>
            </Modal>
        </Show>
    )
}
